<template>
    <div class="article-wrapper">
        <article class="content-article">
            <figure class="featured">
                <span class="img-name" style="background-image:url('images/test.png')"></span>
            </figure>
            <div class="article-info">
                <p>{{this.offer.Headline}}</p>
                <div class="">
                    <a href="javascript:;" @click.prevent="showOfferModal" v-show="user && user.total_aggregators_count == user.total_aggregators_enrolled_in && this.user.total_aggregators_count > 0" class="button pink midsize mid mb-3">Add to Card</a>
                </div>
                <p class="note">You can also make an in-store purchase </p>

                <div class="expires black" v-if="isNaN(this.offer.EventEndDate)">{{ 'Expires - ' + this.offer.EventEndDate }} </div>
                <div class="expires" v-show="!isNaN(this.offer.EventEndDate)">Expires
                    <span v-if="this.offer.EventEndDate == 1">today</span>
                    <span v-if="this.offer.EventEndDate != 1">
                            {{ 'in ' + this.offer.EventEndDate }}
                        <span v-if="this.offer.EventEndDate > 1">days</span>
                        <span v-if="this.offer.EventEndDate == 1">day</span>
                    </span>
                </div>
                <div class="mt-3">
                    <a href="javascript:;" @click.prevent="showOfferModal" class="txt-grey fs-5">View details</a>
                </div>
            </div>
        </article>
        <offer-details-component></offer-details-component>
    </div>

</template>

<script>
    import OfferDetailsComponent from './modals/OfferDetailsComponent.vue';
    export default {
        components: { OfferDetailsComponent },
        props: ['offer'],
        name: "FeaturedOfferComponent",
        data() {
            return {
                user: null,
            }
        },
        methods: {
            showOfferModal() {
                $.colorbox({
                    inline: true, href:'#offer-details-modal', width: '80%', maxWidth:'800px', opacity: '0.90', closeButton: false,
                    onComplete : function() {
                        setTimeout(function(){
                            $.colorbox.resize();
                        }, 500);
                    }
                });
            },
        },
        mounted() {
            if(localStorage.getItem('user_obj')) {
                this.user = JSON.parse(localStorage.getItem('user_obj'));
            }
        }
    }
</script>

<style lang="scss" scoped>
    //@import "../../sass/app.scss";
    .add-to-card {
        background-color: grey;
        color:white;
        border-radius: 40px;
        font-size: 4vm;


        border: none;
        /*color: white;*/
        padding: 7px;
        text-align: center;
        text-decoration: none;
        display: inline-block;
        /*font-size: 16px;*/
        margin: 4px 2px;
        cursor: pointer;

    }
</style>
